export const receitaAcumulada = {
  labels: ["01/04", "02/04", "03/04", "04/04", "05/04"],
  series: [
    {
      valueMesAnterior: [1000, 1500, 1800, 2000, 2500],
      valueMesAtual: [1200, 1600, 1900, 2300, 2700],
    },
  ],
};

export const numVendas = {
  labels: ["01/04", "02/04", "03/04", "04/04", "05/04"],
  series: [
    {
      valueMesAnterior: [50, 60, 65, 70, 80],
      valueMesAtual: [55, 65, 70, 75, 90],
    },
  ],
};
export const receitaPorDiaDaSemana = {
  labels: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  series: [
    {
      valueMesAnterior: [300, 500, 450, 600, 700, 900, 1000],
      valueMesAtual: [350, 550, 470, 650, 750, 950, 1100],
    },
  ],
};

export const receitaTipoPedido = {
  labels: ["Delivery", "Presencial", "Balcão"],
  series: [
    {
      valueMesAnterior: [2500, 3000, 1200],
      valueMesAtual: [2700, 3300, 1400],
    },
  ],
};

export const valorItensMaisVendidos = {
  labels: ["Pizza Margherita", "X-Burguer", "Coca-Cola", "Pastel", "Lasanha"],
  series: [
    {
      valueMesAtual: [3000, 2500, 2200, 1800, 1600],
    },
  ],
};
export const quantItensMaisVendidos = {
  labels: ["Coca-Cola", "X-Burguer", "Pizza Margherita", "Pastel", "Lasanha"],
  series: [
    {
      valueMesAtual: [150, 120, 100, 90, 80],
    },
  ],
};
